module.exports = __webpack_public_path__ + "img/07.6779e396.jpg";